export const GET_REPORT_PROPERTIES = "GET_REPORT_PROPERTIES";
export const GET_BROCHURE = "GET_BROCHURE";
export const GET_BROCHURE_LIST = "GET_BROCHURE_LIST";
export const GET_BROCHURE_LIST_SUCCESS = "GET_BROCHURE_LIST_SUCCESS";
export const GET_BROCHURE_SUCCESS = "GET_BROCHURE_SUCCESS";
export const GET_PROPERTIES_DISCONTINUED = "GET_PROPERTIES_DISCONTINUED";
export const GET_PROPERTIES_DISCONTINUED_SUCCESS = "GET_PROPERTIES_DISCONTINUED_SUCCESS";

export const getReportProperties = (data) => ({
    type: GET_REPORT_PROPERTIES,
    payload: data,
  });
  
  export const getBrochure = properties => ({
    type: GET_BROCHURE,
    payload: properties,
  });

    export const getBrochureList = filter => ({
    type: GET_BROCHURE_LIST,
    payload: filter,
  });

  export const getBrochureListSuccess = data => ({
    type: GET_BROCHURE_LIST_SUCCESS,
    payload: data,
  })

  export const getBrochureSuccess = flag => ({
    type: GET_BROCHURE_SUCCESS,
    payload: flag,
  })

    export const getReportPropertiesDiscontinued = properties => ({
    type: GET_PROPERTIES_DISCONTINUED,
    payload: properties,
  });

  export const getReportPropertiesDiscontinuedSuccess = flag => ({
    type: GET_PROPERTIES_DISCONTINUED_SUCCESS,
    payload: flag,
  })